<template>
  <v-container
    fill-height
    fluid
    class="pa-0 grey lighten-4 overflow-hidden"
  >
    <v-row
      justify="center"
      class="fill-height"
    >
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp"
        cols="5"
        class="pa-0"
      >
        <div
          class="login-left px-10 px-lg-12 px-xl-14"
        >
          <div style="height: 80%; display: flex;">
            <div
              height="70%"
              style="margin: auto;"
            >
              <p class="text-h5 font-weight-bold py-4">
                {{ $t('login.what_is_quats') }}
              </p>
              <p>{{ $t('login.quats_desc_1') }}</p>
              <p>{{ $t('login.quats_desc_2') }}</p>
              <v-btn
                class="mt-4"
                href="https://achievement.co.jp/quats/"
                target="_blank"
              >
                {{ $t('login.detail') }}
              </v-btn>
            </div>
          </div>
          <div style="height: 20%; display: flex;">
            <div
              height="30%"
              style="margin-top: auto; margin-bottom: auto;"
            >
              <a
                style="color: white; text-decoration: underline;"
                target="_blank"
                href="https://achievement.co.jp/policy/"
              >{{ $t('login.privacy_policy') }}</a>
              <p
                v-if="$i18n.locale==='jp'"
                class="pt-4 subtitle-2"
              >
                お問合せ : ( カスタマーサービスセンター、QUATS開発担当 )<br>
                Email : info@achievement.co.jp<br>
                TEL : 0120-000-638
              </p>
              <p
                v-if="$i18n.locale==='en'"
                class="pt-4 subtitle-2"
              >
                Contact : ( Customer Service Center, QUATS development staff )<br>
                Email : info@achievement.co.jp<br>
                TEL : 0120-000-638
              </p>
            </div>
          </div>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="7"
        :class="$vuetify.breakpoint.mdAndUp ? 'pa-0' : 'pa-8'"
      >
        <v-container
          fill-height
          fluid
        >
          <v-row
            justify="center"
            align="center"
          >
            <v-container
              fluid
              class="pa-0 pa-md-4 pa-lg-8"
            >
              <v-row
                justify="center"
              >
                <v-col
                  cols="12"
                  sm="8"
                  lg="6"
                  class="text-center pb-15 pt-0"
                >
                  <v-img
                    src="/img/quats-logo.png"
                  />
                </v-col>
              </v-row>
              <v-row
                v-if="error"
                justify="center"
              >
                <v-col
                  cols="12"
                  md="10"
                  lg="8"
                >
                  <v-alert
                    v-if="error"
                    dense
                    type="error"
                    close-icon="mdi-close-circle-outline"
                    :dismissible="true"
                  >
                    {{ error.message }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-form
                ref="loginForm"
                lazy-validation
              >
                <v-row justify="center">
                  <v-col
                    cols="12"
                    md="10"
                    lg="8"
                  >
                    <v-text-field
                      ref="input-0"
                      v-model="loginId"
                      :placeholder="$t('login.quats_id')"
                      outlined
                      hide-details="auto"
                      :rules="loginIdRules"
                      @focus="currentIndex = 0"
                      @keydown.enter="focusNext"
                    />
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col
                    cols="12"
                    md="10"
                    lg="8"
                  >
                    <v-text-field
                      ref="input-1"
                      v-model="password"
                      type="password"
                      :placeholder="$t('login.password')"
                      outlined
                      hide-details="auto"
                      :rules="passwordRules"
                      @keydown.enter="login"
                    />
                  </v-col>
                </v-row>
              </v-form>

              <v-row
                justify="center"
              >
                <v-col
                  cols="12"
                  md="10"
                  lg="8"
                >
                  <router-link
                    style="text-decoration: underline;"
                    class="text-primary"
                    :to="'/forgot-password'"
                  >
                    {{ $t('login.forget_password') }}
                  </router-link>
                </v-col>
              </v-row>
              <v-row
                justify="center"
                class="mt-0"
              >
                <v-col
                  cols="12"
                  md="10"
                  lg="8"
                >
                  <v-btn
                    :loading="loading"
                    :disabled="loading || externalLoading"
                    block
                    style="color: white;"
                    color="primary"
                    @click="login"
                  >
                    {{ $t('login.login') }}
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  md="10"
                  lg="8"
                >
                  <div class="text-between-divider py-2">
                    <span class="px-2 text-caption">{{ $t('login.or') }}</span>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="10"
                  lg="8"
                >
                  <v-btn
                    :small="$vuetify.breakpoint.xs"
                    class="text-capitalize"
                    color="marcColor"
                    block
                    outlined
                    :loading="externalLoading"
                    :disabled="loading || externalLoading"
                    @click="onLoginWithMarc2Click"
                  >
                    <v-avatar
                      v-if="!loading && !externalLoading"
                      size="20"
                      tile
                    >
                      <v-img
                        src="/img/marc-logo.png"
                        contain
                      />
                    </v-avatar>
                    {{ $t('login.login_via_marc') }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col
                  cols="12"
                  md="10"
                  lg="8"
                >
                  <v-btn
                    :small="$vuetify.breakpoint.xs"
                    :disabled="loading || externalLoading"
                    block
                    outlined
                    target="_blank"
                    href="https://marc2.achievement.co.jp/"
                  >
                    {{ $t('login.to_marc') }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row
                v-if="$vuetify.breakpoint.smAndDown"
                justify="center"
              >
                <v-col
                  cols="12"
                  class="text-center"
                >
                  <a
                    target="_blank"
                    href="https://achievement.co.jp/policy/"
                    style="text-decoration: underline;"
                  >{{ $t('login.privacy_policy') }}</a>
                  <p
                    v-if="$i18n.locale==='jp'"
                    class="pt-4 subtitle-2"
                  >
                    お問合せ : ( カスタマーサービスセンター、QUATS開発担当 )<br>
                    Email : info@achievement.co.jp<br>
                    TEL : 0120-000-638
                  </p>
                  <p
                    v-if="$i18n.locale==='en'"
                    class="pt-4 subtitle-2"
                  >
                    Contact : ( Customer Service Center, QUATS development staff )<br>
                    Email : info@achievement.co.jp<br>
                    TEL : 0120-000-638
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import QUATSError from '../plugins/error'

export default {
  data () {
    return {
      currentIndex: 0,
      loginId: '',
      password: '',
      error: null,
      loading: false,
      externalLoading: false,
      alertData: ''
    }
  },
  computed: {
    loginIdRules () {
      return [
        v => !!v || this.$t('login.quats_id_required'),
        v => {
          const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          const numberPattern = /^[0-9]*$/
          if (emailPattern.test(v)) {
            return true
          } else if (numberPattern.test(v)) {
            return true
          }
          return this.$t('login.quats_id_invalid')
        }
      ]
    },
    passwordRules () {
      return [
        v => !!v || this.$t('login.password_required')
      ]
    }
  },
  created() {
    const query = this.$router.currentRoute.query
    if (query.force_external_oauth_response === 'true') {
      // check if external oauth login response is being redirected here
      if(query.external_oauth_response_error) {
        // if there is any error in external oauth response, show it here
        this.error = new Error(query.external_oauth_response_error)
        this.clearExternalOAuthResponse()
      }
    }
  },
  methods: {
    clearExternalOAuthResponse() {
      return new Promise((resolve) => {
        const query = Object.assign({}, this.$router.currentRoute.query)
        // to avoid loop, reset these two values
        delete query.force_external_oauth_response
        delete query.external_oauth_response_error

        return this.$router.replace({query: query})
          .finally(() => resolve())
      })
    },
    /**
     * @desc to perform login for QUATS
     * @returns {Promise<void>}
     */
    login () {
      if(this.$refs.loginForm.validate()) {
        this.loading = true
        this.error = null
        const loginCredentials = {
          login_id: this.loginId,
          password: this.password
        }
        return window.axios.head('/sanctum/csrf-cookie')
          .then(() => {
            return window.axios.post('/api/auth/login', loginCredentials)
              .then(res => {
                this.$store.commit('account/user', res.data.data)
                window.axios.post('/api/home/course/report/questionnaire')
                this.$router.push({name: 'Home'})
              }).catch(err => {
                this.error = new QUATSError(this.$i18n, err)
              }).finally(() => {
                this.loading = false
              })
          }).catch(err => {
            this.error = err
            this.loading = false
          })
      }
    },

    /**
     * @desc to move the login process form input from one field to another
     */
    focusNext() {
      this.currentIndex += 1
      const nextElement = this.$refs[`input-${this.currentIndex}`]
      if (nextElement) nextElement.focus()
    },

    /**
     * @desc to forward to marc for login
     */
    onLoginWithMarc2Click () {
      this.error = null
      this.externalLoading = true
      window.location = '/oauths/forward/marc2' + window.location.search
    }
  }
}
</script>
<style scoped>
.login-left {
  background-image: url(../../../public/img/quats-bg.jpg);
  background-size: cover;
  height: 100%;
  width: 100%;
  color: white;
  text-align: justify;
}

.text-between-divider {
  display: flex;
  align-items: center;
}

.text-between-divider::before,
.text-between-divider::after {
  content: '';
  height: 1px;
  background-color: silver;
  flex-grow: 1;
}
</style>
